export default __webpack_public_path__ + "static/media/mb-logo.1e1bb433.png";